// todo create enum for all the tables and forms, not only reports
// used as definition.tableId and as key in LocalSettings
export enum ReportId {
    AccountAnalysis = "AccountAnalysisReport",
    AccountingJournal = "AccountingJournalReport",
    AgingAP = "AgingAPReport",
    AgingAR = "AgingARReport",
    AssetAnalysis = "AssetAnalysisReport",
    BalanceSheet = "BalanceSheetReport",
    CbaEntryLedger = "CbaEntryLedgerReport",
    CbaExpensesAndRevenue = "CbaExpensesAndRevenue",
    CbaIncomeExpense = "CbaIncomeExpenseReport",
    DocumentJournal = "DocumentJournalReport",
    ExchangeRate = "ExchangeRateReport",
    ExpensesAndRevenue = "ExpensesAndRevenueReport",
    GeneralLedger = "GeneralLedgerReport",
    IncomeStatement = "IncomeStatementReport",
    PaymentJournal = "PaymentJournalReport",
    ReceivableAdjustments = "ReceivableAdjustmentsReport",
    Saldo = "SaldoReport",
    VatControlStatement = "VatControlStatementReport",
    VatOssStatement = "VatOssStatementReport",
    VatStatement = "VatStatementReport",
    VatVIESStatement = "VatVIESStatementReport",
    GrantJournal = "GrantJournalReport",
    PayrollOverview = "PayrollOverviewReport",
    BenefitOverview = "BenefitOverviewReport",
    DeductionOverview = "DeductionOverviewReport",
    HealthInsuranceContributionsOverview = "HealthInsuranceContributionsOverviewReport",
    OverviewOfTaxCreditsAndTaxAllowances = "OverviewOfTaxCreditsAndTaxAllowancesReport",
    SocialSecurityContributionsOverview = "SocialSecurityContributionsOverviewReport",
    VacationAndSickDaysOverview = "VacationAndSickDaysOverviewReport",
    AdvanceAndWithholdingTax = "AdvanceAndWithholdingTaxReport"
}